if (!customElements.get('recovure-fly-remove')) {
  customElements.define(
    'recovure-fly-remove',
    class RecovureFlyRemove extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.button?.addEventListener('click', () => this.removeOffer());
      }

      async removeOffer() {
        const cartItems = this.closest('cart-items');
        const paidKey = this.dataset.paidKey;
        const giftKey = this.dataset.giftKey;

        if (!cartItems || !paidKey || !this.button) return;

        const updates = { [paidKey]: 0 };
        if (giftKey) updates[giftKey] = 0;

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        cartItems.classList.add('cart__items--disabled');

        try {
          const sectionsToRender = cartItems.getSectionsToRender();
          const response = await fetch(routes.cart_update_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              updates,
              sections: sectionsToRender.map((section) => section.section),
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();

          if (!response.ok || state.errors) {
            throw new Error(typeof state.errors === 'string' ? state.errors : window.cartStrings.error);
          }

          cartItems.classList.toggle('is-empty', state.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);

          sectionsToRender.forEach((section) => {
            const sectionRoot = document.getElementById(section.id);
            if (!sectionRoot || !state.sections?.[section.section]) return;

            const target = sectionRoot.querySelector(section.selector) || sectionRoot;
            target.innerHTML = cartItems.getSectionInnerHTML(state.sections[section.section], section.selector);
          });

          const liveRegion = document.getElementById('cart-live-region-text');
          if (liveRegion) {
            liveRegion.textContent = 'Offer removed from your cart.';
            liveRegion.setAttribute('aria-hidden', 'false');
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: state,
          });
        } catch (error) {
          const errors = document.getElementById('cart-errors');
          if (errors) errors.textContent = error.message || window.cartStrings.error;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          cartItems.classList.remove('cart__items--disabled');
        }
      }
    }
  );
}
